const Style = ({ attributes, clientId }) => {
	const { textAlign, titleTypo, titleColors, titleActiveColors, contentTypo, contentColors } = attributes;

	return <style dangerouslySetInnerHTML={{
		__html: `
		${titleTypo?.googleFontLink ? `@import url(${titleTypo?.googleFontLink});` : ''}
		${contentTypo?.googleFontLink ? `@import url(${contentTypo?.googleFontLink});` : ''}

		#babAccordion-${clientId} .babAccordion dt, #babAccordion-${clientId} .babAccordion dd{
			text-align: ${textAlign};
		}
		#babAccordion-${clientId} .babAccordion dt{
			${titleTypo?.styles || 'font-size: 16px; font-weight: 700;'}
			${titleColors?.styles || 'color: #fff; background-color: #4527a4;'}
		}
		#babAccordion-${clientId} .babAccordion dt.accordionExpanded{
			${titleActiveColors?.styles || 'color: #fff; background-color: #8344c5;'}
		}
		#babAccordion-${clientId} .babAccordion dd{
			${contentTypo?.styles || 'font-size: 15px;'}
			${contentColors?.styles || 'color: #333; background-color: #ecf0f1;'}
		}
		`.replace(/\s+/g, ' ')
	}} />
}
export default Style;